import React, { useState, useEffect, useRef } from "react";
import { Col, Row } from "react-bootstrap";
import jwt_decode from "jwt-decode";
import { embedDashboard } from "@superset-ui/embedded-sdk";
import * as constants from "../constants/CONSTANT";
import SparkApi from "../api/solisPowerApi";


const SupersetDashboard = ({ supersetDashboardId, supersetDashboardUUID, userEmail }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const dashboardRef = useRef(null);


  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) {
      setError("User token not found");
      return;
    }


    const user = jwt_decode(token);
    loadDashboard(user);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [supersetDashboardId, supersetDashboardUUID, userEmail]);


  const loadDashboard = async (user) => {
    setLoading(true);
    setError(null);


    try {
      // Step 1: Get access token
      const loginResponse = await SparkApi.supersetLogin();
      const access_token = loginResponse.access_token;
      let UUID = supersetDashboardUUID;
      if (!UUID) {
        // Step 2: Generate embedded dashboard if UUID not provided
        const generateResponse = await SparkApi.generateEmbeddedDashboard(
          supersetDashboardId,
          access_token
        );
        UUID = generateResponse?.data?.result?.uuid || null;
      }


      // Step 3: Get guest token
      const guestResponse = await SparkApi.guestToken(access_token, UUID, userEmail);
      const guestToken = guestResponse.token;


      // Step 4: Embed dashboard
      if (dashboardRef.current) {
        embedDashboard({
          id: UUID,
          supersetDomain: constants.PULSE_BASE_URL,
          mountPoint: dashboardRef.current,
          fetchGuestToken: () => guestToken,
          dashboardUiConfig: {
            hideTitle: true,
            hideTab: true,
            hideChartControls: false,
            filters: { expanded: false },
          },
        });


        //  Adjust iframe styling
        const iframe = dashboardRef.current.querySelector("iframe");
        if (iframe) {
          iframe.style.width = "100%";
          iframe.style.minHeight = "800px";
        }
      }


      setLoading(false);
    } catch (err) {
      console.error("Error embedding dashboard:", err);
      setError(err.message || "Failed to load dashboard");
      setLoading(false);
    }
  };


  return (
    <Row className="view-form">
      <Col>
        <div
          id="superset-dashboard"
          ref={dashboardRef}
          style={{ width: "100%", height: "800px" }}
        />
        {loading && <div>Loading dashboard...</div>}
        {error && <div style={{ color: "red" }}>Error: {error}</div>}
      </Col>
    </Row>
  );
};


export default SupersetDashboard;